import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  message,
  Spin,
  Radio,
  Divider,
  Row,
  Col,
  InputNumber,
  Select,
  Collapse,
  Table,
  Tag,
  Space,
  Typography,
  Card,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import {
  GET_GEO_ALL,
  HEADERS_EXPORT_BEN,
  HEADERS_EXPORT_DETAIL,
  POST_CONTNO_DETAIL_SEARCH,
  POST_LOAD_MEMO_NEW,
  POST_INSERT_RESUE_JUDGE,
  POST_NOTIC_LAWSUIT,
} from "../../../API/apiUrls";
import DateCustom from "../../../../hook/DateCustom";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import { optionsLone } from "../constant/LoanTypeConstant";
import {
  DownSquareOutlined,
  UpSquareOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import TokenCheck from "../../../../hook/TokenCheck";
import useLawyerNamesNew from "../../../../hook/UseLawyerNameNew";

const { TextArea } = Input;

// ========================================
// Utility Functions
// ========================================

const calculateCourtFee = (value) => {
  if (!value) return 0;

  let fee;
  if (value <= 300000) {
    fee = value * 0.02;
    fee = fee > 1000 ? 1000 : fee;
  } else {
    fee = value * 0.02;
  }

  return Math.ceil(fee + 100);
};

const calculateLostBenefit = (dataLeasingCase, selectedValue) => {
  if (!dataLeasingCase) return 0;
  console.log("calculateLostBenefit=> dataLeasingCase", dataLeasingCase);
  console.log("calculateLostBenefit=> selectedValue", selectedValue);
  const { usableCapital, lost_profit_amount, balanc, netpay } = dataLeasingCase;
  return lost_profit_amount || 0;
};

/**
 * แปลงข้อมูลจาก POST_CONTNO_DETAIL_SEARCH ให้อยู่ในรูปเดียวกับ dataLeasingCase เดิม
 * - flagLoanNew === 1                → loanNew
 * - flagLoanNew === 2 && loanJudge   → loanJudge
 * - อื่นๆ                            → judge[0]
 */
const mapDetailToLeasingCase = (detail) => {
  if (!detail) return null;
  const { flagLoanNew, loanNew, loanJudge, judge, lawsult } = detail;
  const judgeMain = judge?.[0];
  const num = (v) => Number(v) || 0;

  let mapped;
  if (flagLoanNew === 1 && loanNew) {
    mapped = {
      source: "loanNew",
      contno: loanNew.NEWCONTNO,
      sdate: loanNew.SDATE,
      ncarcst: num(loanNew.NCSHPRC),
      t_nopay: num(loanNew.T_NOPAY),
      tot_upay: num(loanNew.TOT_UPAY),
      hldno: num(loanNew.HLDNO),
      balanc: num(loanNew.LOAN_NEW_TONBALANCE),
      netpay: num(loanNew.LOAN_NEW_SMPAY),
    };
  } else if (flagLoanNew === 2 && loanJudge) {
    const closing = num(loanJudge.closingbalance ?? loanJudge.principalRemain);
    mapped = {
      source: "loanJudge",
      contno: loanJudge.NEW_CONTNO,
      sdate: judgeMain?.SDATE,
      ncarcst: num(loanJudge.NCSHPRC),
      t_nopay: num(loanJudge.T_NOPAY),
      tot_upay: num(loanJudge.TOT_UPAY),
      hldno: num(loanJudge.HLDNO),
      balanc: num(loanJudge.NCSHPRC),
      netpay: num(loanJudge.NCSHPRC) - closing,
    };
  } else if (judgeMain) {
    mapped = {
      source: "judge",
      contno: judgeMain.newContno || judgeMain.CONTNO,
      sdate: judgeMain.SDATE,
      ncarcst: num(judgeMain.judgement),
      balanc: num(judgeMain.TONBALANCE),
      netpay: num(judgeMain.PAY),
    };
  } else {
    return null;
  }

  const remain = mapped.balanc - mapped.netpay;
  return {
    ...mapped,
    usableCapital: remain,
    litigation_capital: num(lawsult?.litigationFunds),
    lost_profit_amount: num(lawsult?.lackOfBenefits),
    detail,
  };
};

// ========================================
// Main Component
// ========================================

const SendToLawyersResue = ({ open, close, dataDefault, funcUpdateStatus }) => {
  const [form] = Form.useForm();
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [signOut] = TokenCheck();
  const [convertDateThai] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const { nameLawyers, loadingUseLawyerNames } = useLawyerNamesNew({
    auto: true,
    toast: false,
  });

  // States
  const [loading, setLoading] = useState(false);
  const [radioStatus, setRadioStatus] = useState(null);
  const [dataLeasingCase, setDataLeasingCase] = useState(null);
  const [dataAsset, setDataAsset] = useState([]);
  const [geoRawData, setGeoRawData] = useState(null);

  const [showNote, setShowNote] = useState(false);
  const [oldMemo, setOldMemo] = useState();

  // ========================================
  // Memoized Values
  // ========================================
  // ============== LAWYER FILTERS ==============
  const filterLawyersByCompany = useCallback((lawyers, userCompany) => {
    if (!Array.isArray(lawyers) || !userCompany) return [];

    const companyIds =
      userCompany === "1" || userCompany === "2" ? [1, 2] : [3];

    return lawyers.filter(
      (item) =>
        companyIds.includes(item.COMPANY_ID) &&
        item.ROLE_ID === 3 &&
        item.ACTIVE_STATUS === 1,
    );
  }, []);

  const transformLawyersToOptions = useCallback((lawyers) => {
    return lawyers.map((item) => ({
      value: item.id,
      label: item.NNAME,
      data: item,
    }));
  }, []);

  const lawyersOption = useMemo(() => {
    if (!nameLawyers?.length || !userCompany) return [];

    const filtered = filterLawyersByCompany(nameLawyers, userCompany);
    const options = transformLawyersToOptions(filtered);

    return [...options];
  }, [
    nameLawyers,
    userCompany,
    filterLawyersByCompany,
    transformLawyersToOptions,
  ]);

  // Options สำหรับ Radio เลือกทุนทรัพย์
  const litigationOptions = useMemo(() => {
    console.log(dataLeasingCase);

    if (!dataLeasingCase) {
      return [{ label: "ไม่พบข้อมูล", value: 0, disabled: true }];
    }
    if (dataLeasingCase.loan) {
      const { tonkong, dok } = dataLeasingCase.loan;
      const totalAmount = tonkong;

      const options = [
        {
          label: `${currencyFormatComma(totalAmount.toFixed(2))} บาท`,
          value: parseFloat(totalAmount.toFixed(2)),
        },
      ];

      options.push(
        {
          label: `300,000 บาท`,
          value: 300000,
        },
        {
          label: `กำหนดเอง`,
          value: 0,
        },
      );

      return options;
    } else {
      const { usableCapital, litigation_capital } = dataLeasingCase;
      const options = [
        {
          label: `${currencyFormatComma(usableCapital || 0)} บาท`,
          value: usableCapital,
        },
      ];
      if (litigation_capital > usableCapital) {
        options.push(
          {
            label: `${currencyFormatComma(litigation_capital)} บาท`,
            value: litigation_capital,
          },
          {
            label: `กำหนดเอง`,
            value: 0,
          },
        );
      } else {
        options.push(
          {
            label: `300,000 บาท`,
            value: 300000,
          },
          {
            label: `กำหนดเอง`,
            value: 0,
          },
        );
      }

      return options;
    }
  }, [dataLeasingCase, currencyFormatComma]);

  // ========================================
  // Geo Data Helper Functions
  // ========================================

  const getProvinceName = useCallback(
    (code) => {
      if (!geoRawData?.province || !code) return "-";
      const province = geoRawData.province.find(
        (p) => String(p.provCode) === String(code),
      );
      return province?.provDesc || code;
    },
    [geoRawData],
  );

  const getDistrictName = useCallback(
    (provinceCode, districtCode) => {
      if (!geoRawData?.district || !provinceCode || !districtCode) return "-";
      const district = geoRawData.district.find(
        (d) =>
          String(d.provCode) === String(provinceCode) &&
          String(d.distCode) === String(districtCode),
      );
      return district?.distDesc || districtCode;
    },
    [geoRawData],
  );

  const getSubDistrictName = useCallback(
    (provinceCode, districtCode, subDistrictCode) => {
      if (
        !geoRawData?.subDistrict ||
        !provinceCode ||
        !districtCode ||
        !subDistrictCode
      )
        return "-";
      const subDistrict = geoRawData.subDistrict.find(
        (s) =>
          String(s.provCode) === String(provinceCode) &&
          String(s.distCode) === String(districtCode) &&
          String(s.subDistCode) === String(subDistrictCode),
      );
      return subDistrict?.subDistDesc || subDistrictCode;
    },
    [geoRawData],
  );

  // ========================================
  // API Calls
  // ========================================

  // Load Geo Data (เฉพาะเมื่อมีทรัพย์ และยังไม่เคยโหลด)
  useEffect(() => {
    if (!dataAsset?.length || geoRawData) return;
    let isMounted = true;
    const controller = new AbortController();

    const loadGeoData = async () => {
      try {
        const res = await axios.get(GET_GEO_ALL, {
          headers: HEADERS_EXPORT_BEN,
          signal: controller.signal,
        });

        if (isMounted) {
          setGeoRawData(res.data);
          console.log("geoRawData loaded:", res.data);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && isMounted) {
          console.error("Error loading geo data:", error);
          message.error(`ไม่พบข้อมูล Geo: ${error.message}`);
        }
      }
    };

    loadGeoData();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [dataAsset, geoRawData]);

  const loadData = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();

    try {
      const [leasingRes, loadOldMemo] = await Promise.allSettled([
        axios.post(
          POST_CONTNO_DETAIL_SEARCH,
          {
            CONTNO: dataDefault.newContno,
          },
          {
            headers: HEADERS_EXPORT_DETAIL,
            signal: controller.signal,
          },
        ),
        axios.post(POST_LOAD_MEMO_NEW, { contractNo: dataDefault.CONTNO }),
      ]);

      console.log("All results:", { leasingRes });

      // ✅ Handle detail response (POST_CONTNO_DETAIL_SEARCH)
      const leasingData =
        leasingRes.status === "fulfilled"
          ? mapDetailToLeasingCase(leasingRes.value?.data)
          : null;
      if (leasingData) {
        console.log("leasingRes:", leasingData);
        setDataLeasingCase(leasingData);
        setDataAsset(leasingRes.value?.data?.asset || []);
      } else {
        console.error("Detail API failed:", leasingRes.reason);
        message.warning("ไม่พบข้อมูลสัญญาในระบบ");
        setDataAsset([]);
      }
      if (
        loadOldMemo.status === "fulfilled" &&
        loadOldMemo.value?.data?.MEMO1
      ) {
        // console.log("loadOldMemo?.data?.MEMO1", loadOldMemo.value?.data?.MEMO1);
        setOldMemo(loadOldMemo.value?.data?.MEMO1);
      } else {
        if (loadOldMemo?.reason?.response?.data === "Session expired") {
          signOut();
        } else {
          message.warning("ไม่พบหมายเหตุระบบ smart dev");
          setOldMemo();
        }
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loading data:", error);
        message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, [dataDefault]);

  // Load data when modal opens
  useEffect(() => {
    if (open) {
      loadData();

      // ✅ สร้าง function สำหรับกำหนด loanType
      const getLoanType = () => {
        const { DATA_TYPE, product } = dataDefault;
        console.log("DATA_TYPE", DATA_TYPE, product);

        // กำหนด mapping ตาม DATA_TYPE และ product
        const loanTypeMap = {
          sfhp: { 1: 1 },
          vsfhp: { 1: 1, 2: 2 },
          rpsl: { 1: 4, 2: 2 },
          lsfhp: { default: 2 },
        };

        // ถ้า DATA_TYPE มี mapping
        if (loanTypeMap[DATA_TYPE]) {
          // ถ้ามี product specific หรือ default
          return (
            loanTypeMap[DATA_TYPE][product] || loanTypeMap[DATA_TYPE].default
          );
        }

        return null;
      };

      // ✅ สร้าง function สำหรับกำหนด subject
      const getSubject = () => {
        const subjectMap = {
          2: "บอกกล่าวบังคับจำนอง",
          5: "บอกกล่าวบังคับจำนอง",
          6: "ผิดสัญญาเช่าซื้อ, สัญญาค้ำประกัน, เรียกค่าเสียหาย (ฟ้องส่วนต่าง)",
          7: "ยักยอกทรัพย์",
          8: "ฉ้อโกง",
        };

        return (
          subjectMap[dataDefault.DATA_TYPE] ||
          "ผิดสัญญาเช่าซื้อ, สัญญาค้ำประกัน, เรียกค่าเสียหาย"
        );
      };

      // Set form values
      form.setFieldsValue({
        loanType: getLoanType(),
        subject: getSubject(),
      });
    }
  }, [open, loadData]);

  // ========================================
  // Form Handlers
  // ========================================

  const onChangeSelectLoanType = useCallback(
    (value) => {
      console.log(`Selected loan type: ${value}`);

      const subjectMap = {
        2: "บอกกล่าวบังคับจำนอง",
        5: "บอกกล่าวบังคับจำนอง",
        6: "ผิดสัญญาเช่าซื้อ, สัญญาค้ำประกัน, เรียกค่าเสียหาย (ฟ้องส่วนต่าง)",
        7: "ยักยอกทรัพย์",
        8: "ฉ้อโกง",
        9: "ยักยอกทรัพย์เช่าซื้อ",
        10: "ยักยอกทรัพย์เงินกู้",
      };

      const subject =
        subjectMap[value] ||
        "ผิดสัญญาเช่าซื้อ, สัญญาค้ำประกัน, เรียกค่าเสียหาย";

      form.setFieldsValue({ subject });
    },
    [form],
  );

  const onChangeInvestiGateResult = useCallback(
    ({ target: { value } }) => {
      setRadioStatus(value);

      const courtFee = calculateCourtFee(value);
      const lostBenefit = calculateLostBenefit(dataLeasingCase, value);

      form.setFieldsValue({
        preLitigationFounds: value,
        courtFee,
        preLostProfitAmount:
          value === 300000 || value === 0 ? 0 : lostBenefit || 0,
      });

      console.log("Selected litigation funds:", value);
      console.log("Calculated court fee:", courtFee);
      console.log("Calculated lost benefit:", lostBenefit);
    },
    [dataLeasingCase, form],
  );

  const onChangelitigationFounds = useCallback(
    (value) => {
      const courtFee = calculateCourtFee(value);
      form.setFieldsValue({ courtFee });
    },
    [form],
  );

  const handleCancel = useCallback(() => {
    console.log("Modal closed");
    form.resetFields();
    close(false);
  }, [close, form]);

  const sendDataResue = useCallback(async () => {
    console.log("leasingRes", dataLeasingCase);

    if (dataLeasingCase?.detail?.lawsult?.LAW_TYPE_ID < 7) {
      message.error("ติดต่อ IT เปลี่ยนประเภทฟ้องเดิม");
      return null;
    }
    const payload = {
      userId: 1,
      idJudge: dataLeasingCase?.detail?.judge?.[0]?.idJudge,
    };
    setLoading(true);
    try {
      const response = await axios.post(POST_INSERT_RESUE_JUDGE, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.status !== 200 || response.data?.status !== "success") {
        throw new Error("ไม่สามารถสร้างฟ้องใหม่ได้");
      }
      console.log("Resue success:", response.data);
      // แจ้งเตือนจากระบบ เช่น สายใหม่ต้องส่งสืบ/ออกบอกเลิกเอง
      response.data.warnings?.forEach((w) => message.warning(w, 6));
      return response.data; // { CONTNO, loanId, fromIdJudge, copied, warnings }
    } catch (error) {
      console.error("Error sending resue:", error);
      const errorMsg = error.response?.data?.message || error.message;
      message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      return null;
    } finally {
      setLoading(false);
    }
  }, [dataLeasingCase]);

  const sendDataLawsuit = useCallback(
    async (dataLawsuit) => {
      console.log("Sending data...");
      console.log("dataLawsuit:", dataLawsuit);
      setLoading(true);
      try {
        const response = await axios.post(POST_NOTIC_LAWSUIT, dataLawsuit, {
          headers: HEADERS_EXPORT_BEN,
        });

        if (response.status === 200) {
          console.log("Data sent successfully:", response.data);
          message.success("บันทึกข้อมูลสำเร็จ");
          funcUpdateStatus?.();
          handleCancel();
        } else {
          throw new Error("ไม่สามารถบันทึกข้อมูลได้");
        }
      } catch (error) {
        console.error("Error sending data:", error);
        const errorMsg = error.response?.data?.message || error.message;
        message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      } finally {
        setLoading(false);
      }
    },
    [funcUpdateStatus, handleCancel],
  );

  const onFinish = useCallback(
    async (values) => {
      console.log("Form submitted:", values);

      // 1) สร้างฟ้องใหม่ก่อน
      const resue = await sendDataResue();
      if (!resue?.loanId) return;

      // 2) สำเร็จแล้วค่อยส่งฟ้อง โดยใช้ loanId / CONTNO จาก response ของ sendDataResue
      const dataLawsuit = {
        lawsuitId: 0,
        lackOfBenefits: null,
        preLackOfBenefits: values.preLostProfitAmount,
        fee: values.courtFee,
        litigationFunds: null,
        preLitigationFunds: values.preLitigationFounds,
        mark: values.memo || null,
        subject: values.subject || null,
        LAW_TYPE_ID: values.loanType || null,
        loanId: resue.loanId,
        LOAN_TYPE_ID: null,
        COMPANY_ID: null,
        dateOfPlaint: null,
        provincialCourt: null,
        blackCaseNumber: null,
        suspensionAmount: null,
        considerationDate: null,
        trackingFee: null,
        customerType: null,
        judgeType: null,
        judgeDate: null,
        userId: userId,
        workExpenseList: [],
        userIdLawyer: values.lawyerChoose ? values.lawyerChoose : null,
        CONTNO: resue.CONTNO,
      };
      console.log("--->", dataLawsuit);

      await sendDataLawsuit(dataLawsuit);
    },
    [sendDataResue, sendDataLawsuit, userId],
  );

  const onFinishFailed = useCallback((errorInfo) => {
    console.log("Form validation failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน");
  }, []);

  // ========================================
  // Table Columns
  // ========================================

  const assetColumns = useMemo(
    () => [
      {
        title: "ประเภททรัพย์",
        dataIndex: "typeLand",
        key: "typeLand",
        width: 120,
        render: (type) => {
          const typeMap = {
            1: "โฉนด",
            2: "นส.3ก.",
            3: "ห้องชุด",
            4: "อาคารชุด",
            5: "นภ.1",
            6: "อื่น ๆ",
          };
          return typeMap[type] || "-";
        },
      },
      {
        title: "เลขที่ดิน",
        dataIndex: "numberLand",
        key: "numberLand",
        width: 150,
      },
      {
        title: "จังหวัด",
        dataIndex: "province",
        key: "province",
        width: 150,
        render: (code) => getProvinceName(code),
      },
      {
        title: "อำเภอ",
        dataIndex: "district",
        key: "district",
        width: 150,
        render: (code, record) => getDistrictName(record.province, code),
      },
      {
        title: "ตำบล",
        dataIndex: "subdistrict",
        key: "subdistrict",
        width: 150,
        render: (code, record) =>
          getSubDistrictName(record.province, record.district, code),
      },
    ],
    [getProvinceName, getDistrictName, getSubDistrictName],
  );

  // ========================================
  // Render Components
  // ========================================

  const InfoItem = useCallback(
    ({ label, value, span = 8 }) => (
      <Col xs={24} sm={12} md={span}>
        <div
          style={{
            display: "flex",
            padding: "8px 0",
            borderBottom: "1px solid #f0f0f0",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontWeight: "600",
              minWidth: "140px",
              color: "#666",
            }}
          >
            {label}:
          </span>
          <span
            style={{
              flex: 1,
              color: "#000",
              paddingLeft: "12px",
            }}
          >
            {value}
          </span>
        </div>
      </Col>
    ),
    [],
  );

  const renderDetailLoan = useMemo(() => {
    const assetItems = dataAsset.map((person, index) => {
      const hasAsset = person.assetLand && person.assetLand.length > 0;
      const activeAssets = person.assetLand?.filter((a) => a.active) || [];

      return {
        key: String(index),
        label: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span>
              <strong>
                {person.SNAM}
                {person.NAME1} {person.NAME2}
              </strong>
              {person.garno > 0 && (
                <Tag color="orange" style={{ marginLeft: 8 }}>
                  {person.relation || `คนค้ำที่ ${person.garno}`}
                </Tag>
              )}
              {person.garno === 0 && (
                <Tag color="blue" style={{ marginLeft: 8 }}>
                  {person.relation || "ผู้เช่าซื้อ"}
                </Tag>
              )}
            </span>
            <span>
              <Tag color={hasAsset ? "green" : "red"}>
                {hasAsset
                  ? `พบทรัพย์ ${activeAssets.length} รายการ`
                  : "ไม่พบทรัพย์"}
              </Tag>
            </span>
          </div>
        ),
        children: (
          <div>
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={8}>
                <strong>เลขบัตร:</strong> {person.CUSCOD || "-"}
              </Col>
              <Col span={8}>
                <strong>ความสัมพันธ์:</strong> {person.relation || "-"}
              </Col>
            </Row>

            {hasAsset ? (
              <>
                <Divider orientation="left" style={{ margin: "12px 0" }}>
                  รายการทรัพย์สิน
                </Divider>
                <Table
                  dataSource={person.assetLand}
                  columns={assetColumns}
                  rowKey="landId"
                  pagination={false}
                  size="small"
                  bordered
                  scroll={{ x: 800 }}
                />
              </>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  color: "#999",
                }}
              >
                ไม่มีข้อมูลทรัพย์สิน
              </div>
            )}
          </div>
        ),
      };
    });

    return (
      <>
        <Divider>รายละเอียดทรัพย์</Divider>
        {dataAsset.length > 0 ? (
          <Collapse items={assetItems} style={{ marginBottom: 16 }} />
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              border: "1px solid #e8e8e8",
              borderRadius: "8px",
              marginBottom: 16,
              color: "#999",
            }}
          >
            ไม่มีข้อมูลทรัพย์สิน
          </div>
        )}
      </>
    );
  }, [dataAsset, assetColumns]);

  const renderFormDataSet = useMemo(() => {
    if (!dataLeasingCase) return null;

    return (
      <>
        <Divider>รายละเอียดของสัญญา {dataLeasingCase?.contno}</Divider>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <Row gutter={[16, 0]}>
            <InfoItem
              label="วันที่ทำสัญญา"
              value={convertDateThai(dataLeasingCase?.sdate)}
            />
            <InfoItem
              label="ยอดกู้"
              value={`${currencyFormatComma(
                dataLeasingCase?.ncarcst || 0,
              )} บาท`}
            />
            <InfoItem
              label="ดอกเบี้ยเช่าซื้อ"
              value={`${currencyFormatComma(
                dataLeasingCase?.netprofit || 0,
              )} บาท`}
            />
            <InfoItem
              label="ภาษีเช่าซื้อ"
              value={`${currencyFormatComma(dataLeasingCase?.vatprc || 0)} บาท`}
            />
            <InfoItem
              label="ยอดเช่าซื้อทั้งหมด"
              value={`${currencyFormatComma(dataLeasingCase?.balanc || 0)} บาท`}
            />
            <InfoItem
              label="งวดทั้งหมด"
              value={`${dataLeasingCase?.t_nopay || 0} งวด`}
            />
            <InfoItem
              label="ค่างวด"
              value={`${currencyFormatComma(
                dataLeasingCase?.tot_upay || 0,
              )} บาท`}
            />
            <InfoItem
              label="ชำระมาแล้ว"
              value={`${currencyFormatComma(dataLeasingCase?.netpay || 0)} บาท`}
            />
            <InfoItem
              label="เงินที่จ่ายไม่เต็มงวด"
              value={`${currencyFormatComma(
                dataLeasingCase?.payment || 0,
              )} บาท`}
            />
            <InfoItem
              label="ค่าส่งจดหมาย"
              value={`${currencyFormatComma(
                dataLeasingCase?.collectionFee || 0,
              )} บาท`}
            />
            <InfoItem
              label="รับฝาก"
              value={`${currencyFormatComma(
                dataLeasingCase?.total_hd_payment_amount || 0,
              )} บาท`}
            />
            <InfoItem
              label="ค้างงวด"
              value={`${dataLeasingCase?.hldno || 0} งวด`}
            />

            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  padding: "12px 16px",
                  background: "#fff2f0",
                  border: "1px solid #ffccc7",
                  borderRadius: "4px",
                  marginTop: "8px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    minWidth: "140px",
                  }}
                >
                  ยอดคงเหลือ:
                </span>
                <span
                  style={{
                    flex: 1,
                    color: "#ff4d4f",
                    fontWeight: "bold",
                    fontSize: "18px",
                    paddingLeft: "12px",
                  }}
                >
                  {currencyFormatPoint(
                    dataLeasingCase?.balanc - dataLeasingCase?.netpay || 0,
                  )}{" "}
                  บาท
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }, [
    dataLeasingCase,
    convertDateThai,
    currencyFormatComma,
    currencyFormatPoint,
  ]);

  const renderFormDataSetLoand = useMemo(() => {
    if (!dataLeasingCase) return null;

    return (
      <>
        <Divider>รายละเอียดของสัญญา {dataLeasingCase?.contno}</Divider>
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <Row gutter={[16, 0]}>
            <InfoItem
              label="วันที่ทำสัญญา"
              value={convertDateThai(dataLeasingCase?.loan?.sdate)}
            />
            <InfoItem
              label="ยอดกู้"
              value={`${currencyFormatComma(
                dataLeasingCase?.loan?.ncshprc || 0,
              )} บาท`}
            />

            <InfoItem
              label="งวดทั้งหมด"
              value={`${dataLeasingCase?.loan?.tnopay || 0} งวด`}
            />
            <InfoItem
              label="ค่างวด"
              value={`${currencyFormatComma(
                dataLeasingCase?.loan?.totUpay || 0,
              )} บาท`}
            />

            <InfoItem
              label="ดอก"
              value={`${currencyFormatComma(
                dataLeasingCase?.loan?.dok || 0,
              )} บาท`}
            />
            <InfoItem
              label="ค้างดอก"
              value={`${currencyFormatComma(
                (dataLeasingCase?.loan?.kangdok || 0).toFixed(2),
              )} บาท`}
            />
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  padding: "12px 16px",
                  background: "#fff2f0",
                  border: "1px solid #ffccc7",
                  borderRadius: "4px",
                  marginTop: "8px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    minWidth: "140px",
                  }}
                >
                  ยอดคงเหลือ:
                </span>
                <span
                  style={{
                    flex: 1,
                    color: "#ff4d4f",
                    fontWeight: "bold",
                    fontSize: "18px",
                    paddingLeft: "12px",
                  }}
                >
                  {currencyFormatPoint(dataLeasingCase?.loan?.tonkong)} บาท
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }, [
    dataLeasingCase,
    convertDateThai,
    currencyFormatComma,
    currencyFormatPoint,
  ]);

  const renderDataForLawsuit = useMemo(() => {
    return (
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        style={{ marginTop: "24px" }}
        initialValues={{
          preLostProfitAmount: dataLeasingCase?.lost_profit_amount || 0,
        }}
      >
        <Divider orientation="left" style={{ marginBottom: 0 }}>
          <Space
            onClick={() => setShowNote((prev) => !prev)}
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            <Typography.Text strong>หมายเหตุโปรแกรมภายใน</Typography.Text>
            <Tag
              color={showNote ? "blue" : "default"}
              style={{ marginInlineEnd: 0 }}
            >
              {showNote ? <UpSquareOutlined /> : <DownSquareOutlined />}
            </Tag>
          </Space>
        </Divider>

        {showNote && (
          <Card
            size="small"
            style={{
              marginTop: 8,
              borderRadius: 8,
              background: "#fffbe6",
              borderColor: "#ffe58f",
            }}
            styles={{ body: { padding: "10px 16px" } }}
          >
            <Space align="start">
              <InfoCircleOutlined style={{ color: "#faad14", marginTop: 2 }} />
              <Typography.Text
                style={{ color: "#614700", whiteSpace: "pre-wrap" }}
              >
                {oldMemo || "-"}
              </Typography.Text>
            </Space>
          </Card>
        )}
        <Divider>ข้อมูลการฟ้อง</Divider>
        <Row gutter={[16, 8]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="ความ"
              name="loanType"
              // rules={[{ required: true, message: "กรุณาเลือกประเภทสัญญา" }]}
            >
              <Select
                placeholder="โปรดเลือกประเภทการฟ้อง"
                showSearch
                optionFilterProp="label"
                options={optionsLone}
                onChange={onChangeSelectLoanType}
                allowClear
                size="large"
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="เรื่อง"
              name="subject"
              // rules={[
              //   {
              //     required: true,
              //     message: "กรุณาพิมพ์เรื่องที่ยื่นฟ้อง",
              //   },
              // ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label={`เลือกทุนทรัพย์ที่จะใช้ฟ้อง`}
              name="litigation"
              // rules={[{ required: true, message: "กรุณาเลือกทุนทรัพย์" }]}
            >
              <Radio.Group
                options={litigationOptions}
                onChange={onChangeInvestiGateResult}
                value={radioStatus}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              label="จำนวนทุนทรัพย์"
              name="preLitigationFounds"
              rules={[{ required: true, message: "กรุณาใส่จำนวนทุนทรัพย์" }]}
            >
              <InputNumber
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                size="large"
                placeholder="กรุณาใส่จำนวนทุนทรัพย์"
                style={{ width: "100%" }}
                onChange={onChangelitigationFounds}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              label="ค่าขาดประโยชน์"
              name="preLostProfitAmount"
              rules={[{ required: true, message: "กรุณาใส่ค่าขาดประโยชน์" }]}
            >
              <InputNumber
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                size="large"
                placeholder="กรุณาใส่ค่าขาดประโยชน์"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              label="ค่าธรรมเนียมศาล"
              name="courtFee"
              rules={[
                {
                  required: true,
                  message: "กรุณาใส่ค่าธรรมเนียมศาล",
                },
              ]}
            >
              <InputNumber
                precision={2}
                suffix="บาท"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                size="large"
                placeholder="กรุณาใส่ค่าธรรมเนียมศาล"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="กำหนดทนายความ"
              name="lawyerChoose"
              rules={[{ required: true, message: "กรุณาเลือกทนายความ" }]}
            >
              <Select
                placeholder="เลือกทนายความ"
                options={lawyersOption}
                loading={loadingUseLawyerNames}
                showSearch
                optionFilterProp="label"
                disabled={!lawyersOption.length}
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Note เดิมของคดี (จาก POST_CONTNO_DETAIL_SEARCH) */}
        {dataLeasingCase?.detail?.note?.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            <Typography.Text strong>
              บันทึก ({dataLeasingCase.detail.note.length})
            </Typography.Text>
            <Space
              direction="vertical"
              size={8}
              style={{ width: "100%", marginTop: 8 }}
            >
              {dataLeasingCase.detail.note.map((item) => (
                <Card
                  key={item.id}
                  size="small"
                  style={{
                    borderRadius: 8,
                    background: "#f6ffed",
                    borderColor: "#b7eb8f",
                  }}
                  styles={{ body: { padding: "8px 14px" } }}
                >
                  <Typography.Text style={{ whiteSpace: "pre-wrap" }}>
                    หมายเหตุ : {item.note || "-"}
                  </Typography.Text>
                  <div style={{ fontSize: 10, color: "#888", marginTop: 4 }}>
                    <Tag style={{ marginInlineEnd: 6, fontSize: 8 }}>
                      ผู้บันทึก {item.USERNAME || "-"}
                    </Tag>
                    {item.CreatedAt
                      ? dayjs(item.CreatedAt)
                          .add(543, "year")
                          .format("D MMM YY HH:mm")
                      : "-"}
                  </div>
                </Card>
              ))}
            </Space>
          </div>
        )}

        <Form.Item label="หมายเหตุ" name="memo">
          <TextArea rows={6} placeholder="กรอกหมายเหตุ (ถ้ามี)" />
        </Form.Item>

        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <Button
            onClick={handleCancel}
            danger
            style={{ marginRight: "12px" }}
            size="large"
          >
            ยกเลิก
          </Button>

          <Button type="primary" htmlType="submit" size="large">
            บันทึก
          </Button>
        </div>
      </Form>
    );
  }, [
    form,
    onFinish,
    onFinishFailed,
    dataLeasingCase,
    // lawyersOption,
    // loadingUseLawyerNames,
    onChangeSelectLoanType,
    litigationOptions,
    onChangeInvestiGateResult,
    radioStatus,
    onChangelitigationFounds,
    handleCancel,
  ]);

  // ========================================
  // Main Render
  // ========================================

  return (
    <Modal
      title="ส่งทนายฟ้องสัญญา"
      open={open}
      onCancel={handleCancel}
      width={1200}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
        {renderDetailLoan}
        {dataLeasingCase?.loan ? renderFormDataSetLoand : renderFormDataSet}
        {renderDataForLawsuit}
      </Spin>
    </Modal>
  );
};

export default SendToLawyersResue;
